<template>
  <div>
    <b-modal
      ref="mycommentmodal"
      hide-footer
      hide-header
      content-class="modal-content-just-success"
    >
      <div class="d-block">
        <div class="float-right">
            <span @click="$refs.mycommentmodal.hide()"
              ><i class="fas fa-times-circle text-danger close-btn-icon"></i
            ></span></div>
        <h3 style="font-size:1.5em;">ให้คะแนน</h3>
        <b-form-group
        class="paddingkung"
          label="กรอกความคิดเห็น"
          label-for="textarea"
          :invalid-feedback="v_commenttext.message"
        >
          <b-form-textarea
            style="overflow: auto"
            id="textarea"
            rows="3"
            max-rows="6"
            v-model="commenttext"
            :state="v_commenttext.state"
          ></b-form-textarea>
        </b-form-group>
        <div style="text-align: left;display:flex;">
          <div class="paddingkung">คะแนน</div>
          <b-form-rating
            id="rating-inline"
            class="reviewratingmodal"
            no-border
            color="#ffd400"
            v-model="commentrating"
          >
          </b-form-rating>
        </div>
      </div>
<div class="d-flex justify-content-center">
      <b-button class="mt-3"  style="width:40%;" variant="warning" block @click="ConfirmComment"
        >ยืนยัน</b-button
      >
</div>
    </b-modal>
  </div>
</template>

<script>
import { createValidation } from "../libs/ValidationHelper";
const validation = createValidation();
export default {
  data() {
    return {
      commentrating: 4,
      commenttext: "",
      isCheckValidate: false
    };
  },

  computed: {
    ...validation.initFuncs({
      v_commenttext() {
        if (!this.commenttext) {
          return "จำเป็นต้องกรอกข้อความ";
        }
        return null;
      }
    })
  },
  methods: {
    showmodal() {
      this.$refs["mycommentmodal"].show();
    },
    hidemodal() {
      validation.uncheck(this);
      this.cleardata();
      this.$refs["mycommentmodal"].hide();
    },
    cleardata() {
      this.commenttext = "";
      this.commentrating = 4;
    },
    ConfirmComment() {
      if (!validation.check(this)) return;
      var myself = this;
      var localbody = {
        Content: myself.commenttext,
        Rate: myself.commentrating
      };
      this.axios({
        method: "post",
        url: "/WebSiteReview/SaveWebSiteReview",
        data: localbody
      })
        .then((response) => {
          this.hidemodal();
          this.$emit("success");
        })
        .catch((error) => {
          alert("ผิดพลาด");
        });
    }
  }
};
</script>
<style>
.reviewratingmodal{
  width: 10em;
}
.paddingkung{
  padding: .375rem .75rem;
}
</style>